import Nullstack from 'nullstack';
export default function IconDnaOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-dna-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M16 12a3.898 3.898 0 0 0 -1.172 -2.828a4.027 4.027 0 0 0 -2.828 -1.172m-2.828 1.172a4 4 0 1 0 5.656 5.656"
  }), "   ", Nullstack.element("path", {
    d: "M9.172 20.485a4 4 0 1 0 -5.657 -5.657"
  }), "   ", Nullstack.element("path", {
    d: "M14.828 3.515a4 4 0 1 0 5.657 5.657"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}